import React from "react";
import AuthLanding from "../AuthLanding/AuthLanding";

const Register = () => {
  return <AuthLanding />;
};

export default Register;
